<template>
	<div class="time-report">
		<section class="report-metrics">
			<div class="report-metric">
				<span>{{ $t('timetrack.reports.total-time') }}</span>
				<strong>{{ $formatters.formatSeconds(metrics.totalTime) }}</strong>
			</div>
			<div class="report-metric">
				<span>{{ $t('timetrack.reports.avg-month') }}</span>
				<strong>{{ $formatters.formatSeconds(metrics.averageMonthTime) }}</strong>
			</div>
			<div class="report-metric">
				<span>{{ $t('timetrack.reports.avg-week') }}</span>
				<strong>{{ $formatters.formatSeconds(metrics.averageWeekTime) }}</strong>
			</div>
		</section>
		<section class="report-chart">
			<h2>{{ $t('timetrack.reports.monthly-hours') }}</h2>
			<time-by-month :timer-events="timerEvents"></time-by-month>
		</section>
		<section class="report-chart">
			<h2>{{ $t('timetrack.reports.time-by-project') }}</h2>
			<time-by-project :timer-events="timerEvents"></time-by-project>
		</section>
	</div>
</template>

<script>
  import { DateTime } from 'luxon';
  import TimeByProject from '@/modules/timetracking/charts/TimeByProject';
  import TimeByMonth from '@/modules/timetracking/charts/TimeByMonth';

  export default {
		name: 'TimerEventCharts',

		props: ['timerEvents','earliest','latest'],

		components: { TimeByProject, TimeByMonth},

		data: function() {
			return {};
		},

		mounted() {},

		beforeDestroy() {},

		methods: {
      sortByDate: function(a,b){
        return a.timerStart.localeCompare(b.timerStart);
      }
		},

		computed: {
      metrics: function() {
        let result = {
          totalTime: 0,
          averageMonthTime: 0,
          averageWeekTime: 0,
        };

        if(this.timerEvents.length === 0){
          return result;
        }

        let events = [...this.timerEvents];
        events.sort(this.sortByDate);

        let weeks = new Map();
        let months = new Map();
        let earliestWeek, earliestMonth, latestWeek, latestMonth;

        if(this.earliest){
          earliestWeek = this.earliest.startOf('week');
          earliestMonth = this.earliest.startOf('month');
        }else{
          earliestWeek = DateTime.fromISO(events[0].timerStart).startOf('week');
          earliestMonth = DateTime.fromISO(events[0].timerStart).startOf('month');
        }

        if(this.latest){
          latestWeek = this.latest.startOf('week');
          latestMonth = this.latest.startOf('month');
        }else{
          latestWeek = DateTime.fromISO(events[events.length-1].timerStart).startOf('week')
          latestMonth = DateTime.fromISO(events[events.length-1].timerStart).startOf('month')
        }

        while(earliestWeek <= latestWeek){
          weeks.set(earliestWeek.toISODate(),0);
          earliestWeek = earliestWeek.plus({week:1})
        }

        while(earliestMonth <= latestMonth){
          months.set(earliestMonth.toISODate(),0);
          earliestMonth = earliestMonth.plus({month:1})
        }

        events.forEach(item => {
          result.totalTime = result.totalTime + item.durationSeconds;

          let monthKey = item.startDate.startOf('month').toISODate();
          let weekKey = item.startDate.startOf('week').toISODate();

          months.set(monthKey,months.get(monthKey) + item.durationSeconds);
          weeks.set(weekKey,weeks.get(weekKey) + item.durationSeconds);
        })

        let monthCount = 0;
        let monthSum = 0;

        let weekCount = 0;
        let weekSum = 0;

        months.forEach((v) => {
          monthCount++;
          monthSum += v;
        })

        weeks.forEach((v) => {
          weekCount++;
          weekSum += v;
        })

        result.averageWeekTime = weekSum/weekCount;
        result.averageMonthTime = monthSum/monthCount;

        return result;
      },
		},
	};
</script>

<style scoped lang="scss">
	.time-report {
		display: grid;
		gap: 16px;
		padding: 16px;
	}

	.report-metrics {
		display: grid;
		grid-template-columns: repeat(3, minmax(0, 1fr));
		gap: 12px;
	}

	.report-metric,
	.report-chart {
		border: 1px solid var(--portal-border);
		border-radius: var(--portal-radius-md);
		background: var(--portal-surface);
	}

	.report-metric {
		display: grid;
		gap: 7px;
		padding: 16px;
	}

	.report-metric span {
		color: var(--portal-muted);
		font-size: 12px;
		font-weight: 600;
	}

	.report-metric strong {
		color: var(--portal-text);
		font-size: clamp(20px, 2.4vw, 28px);
		font-weight: 680;
		letter-spacing: -0.025em;
	}

	.report-chart {
		min-width: 0;
		padding: 18px;
		overflow: hidden;
	}

	.report-chart h2 {
		margin: 0 0 12px;
		color: var(--portal-text);
		font-size: 15px;
		font-weight: 650;
	}

	@media (max-width: 760px) {
		.report-metrics {
			grid-template-columns: minmax(0, 1fr);
		}
	}

	@media (max-width: 599px) {
		.time-report {
			padding: 12px;
		}

		.report-chart {
			padding: 12px;
		}
	}
</style>
